module.exports = __webpack_public_path__ + "img/spielfeld.1615e0ca.png";